// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n3ym","buttons":"styles_buttons__2Liuk"};